import gql from 'graphql-tag'

export default gql`
mutation(
  $businessId: ID!
  $intent: String!
  $orderId: String
  $payerId: String!
  $paymentId: String!
  $paymentToken: String!
  $returnUrl: String
) {
  paypalExecutePayment(
    businessId: $businessId
    intent: $intent
    orderId: $orderId
    payerId: $payerId
    paymentId: $paymentId
    paymentToken: $paymentToken
    returnUrl: $returnUrl
  ) {
    response
  }
}`
